/** Stainless feed trough with the two wall brackets that make its purpose legible. */
import * as THREE from 'three';
import { surface } from '../materials';
import type { AssetDefinition } from '../types';

function part(size: readonly [number, number, number], y: number, z: number, name: string): THREE.Mesh {
  const mesh = new THREE.Mesh(new THREE.BoxGeometry(...size), surface('metal', 0xb9c1c0));
  mesh.name = name;
  mesh.position.set(0, y, z);
  mesh.castShadow = true;
  return mesh;
}

function build(): THREE.Group {
  const group = new THREE.Group();
  group.name = 'feed-trough';
  // A closed box reads as a cabinet in the workbench. Leaving the top genuinely
  // open gives it the sharp U-shaped silhouette of a wash-down trough without
  // adding any decorative detail to this deliberately joyless kit.
  group.add(
    part([0.3, 0.035, 1.2], 0.09, 0, 'trough-bottom'),
    part([0.028, 0.15, 1.2], 0.145, 0, 'trough-side-left'),
    part([0.028, 0.15, 1.2], 0.145, 0, 'trough-side-right'),
  );
  const left = group.getObjectByName('trough-side-left');
  const right = group.getObjectByName('trough-side-right');
  if (left) left.position.x = -0.136;
  if (right) right.position.x = 0.136;
  for (const z of [-0.42, 0.42]) {
    const bracket = new THREE.Mesh(new THREE.BoxGeometry(0.045, 0.19, 0.035), surface('metal', 0x8e9899));
    bracket.name = `mounting-bracket-${z < 0 ? 'back' : 'front'}`;
    bracket.position.set(0, 0.095, z);
    group.add(bracket);
    const foot = new THREE.Mesh(new THREE.BoxGeometry(0.18, 0.02, 0.08), surface('metal', 0x8e9899));
    foot.name = `bracket-foot-${z < 0 ? 'back' : 'front'}`;
    foot.position.set(0, 0.01, z);
    group.add(foot);
  }
  return group;
}

export const feedTroughAsset: AssetDefinition = {
  id: 'feed-trough', label: 'Feed trough', description: 'Open stainless feed trough on two clean steel brackets.',
  footprint: { width: 0.3, height: 0.22, length: 1.2 }, create: build,
};
